import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaAward } from 'react-icons/fa';

export const LoadingScreen = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
      <p className="mt-4 text-gray-600">Verifying invitation...</p>
    </div>
  </div>
);

export const InvitationErrorScreen = ({ message }) => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
    <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center">
      <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <span className="text-3xl">⚠️</span>
      </div>
      <h2 className="text-xl font-bold text-gray-800 mb-2">Invalid Invitation</h2>
      <p className="text-gray-600 mb-6">{message}</p>
      <div className="space-y-3">
        <Link
          to="/pro"
          className="block w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Sign Up Without Invitation
        </Link>
        <Link
          to="/"
          className="block w-full px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
        >
          Return Home
        </Link>
      </div>
    </div>
  </div>
);

export const ExistingApplicationScreen = ({ onTryDifferent }) => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
    <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center" data-testid="existing-application-error">
      <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <span className="text-4xl">📋</span>
      </div>
      <h2 className="text-2xl font-bold text-gray-800 mb-2">Application Already Exists</h2>
      <p className="text-gray-600 mb-6">
        It looks like you've already submitted a professional application with this email address. 
        Your application may be pending review or already approved.
      </p>
      <div className="space-y-3">
        <Link
          to="/login"
          className="block w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
          data-testid="go-to-login"
        >
          Log In to Your Account
        </Link>
        <Link
          to="/"
          className="block w-full px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium"
          data-testid="return-home"
        >
          Return Home
        </Link>
        <button
          onClick={onTryDifferent}
          className="block w-full px-4 py-3 text-blue-600 hover:text-blue-800 font-medium"
          data-testid="try-different-email"
        >
          Try with a Different Email
        </button>
      </div>
      <p className="text-sm text-gray-500 mt-6">
        Need help? Contact us at <a href="mailto:support@legacyrise.com" className="text-blue-600 hover:underline">support@legacyrise.com</a>
      </p>
    </div>
  </div>
);

export const SuccessScreen = ({ token }) => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
    <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center" data-testid="signup-success">
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <FaCheck className="text-green-600 text-3xl" />
      </div>
      <h2 className="text-2xl font-bold text-gray-800 mb-2">Registration Successful!</h2>
      {token ? (
        <>
          <p className="text-gray-600 mb-6">
            Your profile is now Pending Verification. An LFF administrator will review it, and you'll be listed once approved. 
            Families can now find and book consultations with you.
          </p>
          <Link
            to="/login"
            className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
          >
            Log In to Your Dashboard
          </Link>
        </>
      ) : (
        <>
          <p className="text-gray-600 mb-4">
            Thank you for applying! Your profile is now Pending Verification.
            An LFF administrator will review your credentials, and you'll appear in the directory once approved.
          </p>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
            <div className="flex items-center gap-2 text-amber-700 font-semibold mb-1">
              <FaAward /> Founding Advisor Status Granted!
            </div>
            <p className="text-amber-600 text-sm">
              As an early launch partner, you've earned a permanent "Founding Advisor" badge and featured listing in our directory.
            </p>
          </div>
          <Link
            to="/login"
            className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
          >
            Log In to Your Dashboard
          </Link>
        </>
      )}
    </div>
  </div>
);
